/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createNotFoundPageStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
    },
    logoLink: {
      position: 'absolute',
      top: '80px',
    },
    logoImage: {
      width: '163px',
      height: 'auto',
    },
    textBig: {
      fontSize: '149px',
      lineHeight: '106px',
      fontWeight: 700,
      color: '#FEFFFF',
      marginBottom: '40px',
    },
    textSmall: {
      fontSize: '32px',
      lineHeight: '28px',
      letterSpacing: '-0.22px',
      color: '#FEFFFF',
      marginBottom: '70px',
    },
    button: {
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '140px',
      height: '40px',
      borderRadius: '6px',
      backgroundColor: theme.palette.secondary.main,
      color: '#FFFFFF',
      fontSize: '14px',
      lineHeight: '14px',
      letterSpacing: '-0.11px',
      fontWeight: 700,
      '&:hover': {
        backgroundColor: theme.palette.tertiary.main,
      },
    },
  }),
);

export { createNotFoundPageStyles };
